import { FunctionComponent, ReactElement } from 'react'
import { Grow, FormHelperText } from '@mui/material'
import { Translation } from '@dxp-module/common'

type WithErrorMessageProps = {
  className?: string
  children?: ReactElement | ReactElement[] | JSX.Element
  error?: string
  'data-test'?: string
}

const WithErrorMessage: FunctionComponent<WithErrorMessageProps> = ({
  children,
  className,
  error,
  'data-test': dataTest,
}) => {
  return (
    <>
      {children}
      {!!error && (
        <Grow in={!!error} easing={'.1s'}>
          <FormHelperText className={className} data-test={`${dataTest}:error`}>
            <Translation id={error} />
          </FormHelperText>
        </Grow>
      )}
    </>
  )
}

export default WithErrorMessage
